import type { ModelOverrides } from "@9amhealth/openapi";
import type {
  AiChatErrorCode,
  FileAttachment,
  FileRef,
  ToolCall
} from "@9amhealth/shared";

export enum ChatEventType {
  EscalationPrompt = "conversation.escalation.prompt"
}

export type LeapChatFileRef = FileRef;

export interface MessageSendError {
  code: AiChatErrorCode;
  statusCode?: number;
}

export function normalizeMessageError(
  error: string | MessageSendError | undefined
): MessageSendError | undefined {
  if (!error) {
    return undefined;
  }
  if (typeof error === "string") {
    return { code: "unknown" };
  }
  return error;
}

export interface LeapChatMessage {
  id: string;
  localId?: string;
  role: "user" | "assistant";
  text: string;
  toolCalls?: ToolCall[];
  files?: LeapChatFileRef[];
  createdAt: number;
  isLocal?: boolean;
  senderId?: string;
  senderName?: string;
  senderDescription?: string;
  unread?: boolean;
  error?: MessageSendError;
  isGeneratedResponse?: boolean;
}

export interface ChatPromptOption {
  label: string;
  value: string;
  variant?: "primary" | "secondary";
}

export interface ChatPrompt {
  id: string;
  messageId: string;
  conversationId: string;
  eventType: string;
  eventData: unknown;
  options: ChatPromptOption[];
  selectedValue: string | null;
}

export type LeapChatAttachment = FileAttachment;

export const llmModels = [
  {
    llmService: "GEMINI",
    modelName: "gemini-2.5-pro"
  },
  {
    llmService: "GEMINI",
    modelName: "gemini-2.5-flash"
  },
  {
    llmService: "GEMINI",
    modelName: "gemini-2.5-flash-lite"
  },
  {
    llmService: "OPENAI",
    modelName: "gpt-5.4"
  },
  {
    llmService: "OPENAI",
    modelName: "gpt-5.4-pro"
  },
  {
    llmService: "OPENAI",
    modelName: "gpt-5.2"
  },
  {
    llmService: "OPENAI",
    modelName: "gpt-5-mini"
  },
  {
    llmService: "OPENAI",
    modelName: "gpt-5-nano"
  },
  {
    llmService: "ANTHROPIC",
    modelName: "us.anthropic.claude-sonnet-4-20250514-v1:0"
  }
] as const;

export interface DebugOverrides {
  llmModel?: {
    llmService: (typeof llmModels)[number]["llmService"];
    modelName: (typeof llmModels)[number]["modelName"];
  };
  temperature?: number;
  reasoningEffort?: ModelOverrides.reasoningEffort;
  systemPrompt?: string;
}
